import styled from 'styled-components';
import { COLOR_RED } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  min-height: 300px;
  max-width: 500px;
  margin: 0 auto;

  .row {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .headline-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      text-align: center;
      h3 {
        padding-bottom: 10px;
        padding-top: 10px;
      }
    }

    .heading-block {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 25px;
      width: 100%;
      .separator {
        border-radius: 2px;
        background-color: #d9d8dd;
        height: 1px;
        width: 100%;
      }
      p {
        min-width: fit-content;
        padding-right: 20px;
      }
    }

    .half-block {
      padding-top: 15px;
      width: calc(50% - 10px);
    }
    .full-block {
      padding-top: 15px;
      width: 100%;
      &.centered {
        text-align: center;
      }
    }

    .input-wrap {
      position: relative;
      .eye-icon {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 12px;
        padding-right: 16px;
      }
    }

    .form-submit {
      width: 100%;
      margin: 15px 0 10px 0;
    }
  }

  .password-wrapper {
    width: 100%;

    &.hidden {
      visibility: hidden;
      height: 0px;
    }

    &.visible {
      visibility: visible;
      height: auto;
    }
  }

  .inline-loader {
    margin: 0 auto;
  }

  .hidden-btn {
    visibility: hidden;
    height: 0;
  }

  .sms-code-wrapper {
    width: 100%;
    
    .resend-info {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 4px;
      padding-top: 10px;
      text-align: center;
    }
    
    .sms-code {
      width: 100%;
      justify-content: space-between;
      display: flex !important;
      gap: 12px;
      
      @media (max-width: ${BP_MOBILE_MAX}px) {
        gap: 8px;
      }
      
      &.bad-sms input {
        border: 1px solid ${COLOR_RED};
      }
      
      input {
        padding: 12px 15px;
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
        flex: 1;
        min-width: 0;
        border: 1px solid rgba(63, 61, 86, 0.4);
        border-radius: 12px;
        text-align: center;
        -webkit-appearance: none;
        -moz-appearance: textfield;
        
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        &:focus {
          border: 2px solid #3f3d56;
          outline: none;
        }
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .row {
      .half-block {
        width: 100%;
      }
    }
  }
`;

export const LoginFormTextInputSC = styled.input`
  border-radius: 2px;
  min-width: 100%;
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(63, 61, 86, 0.4);
  background-color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  border-radius: 12px;
  -webkit-appearance: none;

  &:read-only {
    opacity: 0.5;
    &:hover,
    &:focus {
      opacity: 0.5;
      border: 1px solid rgba(63, 61, 86, 0.4);
      outline: none;
      box-shadow: none;
    }
  }

  &::placeholder {
    color: #3f3d56;
    opacity: 0.5;
    font-weight: 600;
    font-size: 18px;
  }

  &:focus,
  &:hover {
    border: 1px solid #000000;
    outline: none;
    box-shadow: none;
    ${(props) => (props.hasError ? `border-color: ${COLOR_RED};` : 'border-color: #000000;')}
  }

  ${(props) => (props.hasError ? `color: ${COLOR_RED};` : null)}
  ${(props) => (props.hasError ? `border-color: ${COLOR_RED}` : null)}
`;

export const LoginFormErrorSC = styled.div`
  width: 100%;
  height: auto;
  color: ${COLOR_RED};
`;
